const fullScreenReducer = (state = false, action) => {
  switch (action.type) {
    case 'ENTER_FULL_SCREEN':
      return true;
    case 'EXIT_FULL_SCREEN':
      return false;
    default:
      return state;
  }
};

export default fullScreenReducer;
